import { makeAuthenticatedRequest } from './api';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';

/**
 * Fetches the current user's info from the backend.
 * @returns {Promise<object>} - The user info object from /auth/user-info
 * @throws {Error} - Throws if the request fails or user is not authenticated
 */
export const fetchUserInfo = async () => {
  try {
    const result = await makeAuthenticatedRequest('/auth/user-info', { method: 'POST' });
    console.log('Backend /auth/user-info response:', result);
    return result;
  } catch (error) {
    console.error('Error calling /auth/user-info:', error);
    throw error;
  }
};

/**
 * Signs out the current Firebase user.
 */
export const signOutFirebase = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    // Ignore sign out errors
  }
};

/**
 * Updates the current user's email notification preference.
 * @param {boolean} emailNotificationsEnabled
 */
export const updateNotificationPreference = async (emailNotificationsEnabled) => {
  return makeAuthenticatedRequest('/auth/notification-preference', {
    method: 'PATCH',
    body: { emailNotificationsEnabled },
  });
};

/**
 * Registers the current Firebase user as a demo user on the backend.
 * @param {{ name: string, phone?: string, company?: string }} profileData
 */
export const registerDemoUser = async (profileData) => {
  return makeAuthenticatedRequest('/demo/register', {
    method: 'POST',
    body: profileData,
  });
};

/**
 * Sends a branded verification email via MS Graph through the backend.
 * Uses Firebase Admin SDK to generate the verification link.
 */
export const sendDemoVerificationEmail = async () => {
  return makeAuthenticatedRequest('/demo/send-verification', {
    method: 'POST',
  });
};

/**
 * Sends a welcome email after the user has verified their email address.
 * Idempotent — backend will skip if already sent.
 */
export const sendDemoWelcomeEmail = async () => {
  return makeAuthenticatedRequest('/demo/welcome-email', {
    method: 'POST',
  });
};

/**
 * Marks the welcome modal as seen so it is not shown again on subsequent logins.
 * Idempotent — safe to call multiple times.
 */
export const markDemoWelcomeSeen = async () => {
  return makeAuthenticatedRequest('/demo/mark-welcome-seen', {
    method: 'POST',
  });
};
